module.exports = __webpack_public_path__ + "media/images/landing/crime/product-2-111bb1610d0075b73064c93133ef88f5.png";